/*
sohel 09/27/2022 2700453848 Trigger Group -> Trigger group Client and Agency Type Changes
sohel 09/29/2022 2700453848 Trigger Group ->Added Toast, validation and Event Trigger Changes
sohel 10/10/2022 2700453848 Removed unused Code
sohel 10/10/2022 2700453848 Trigger Group Save API Payload Changes and Event Trigger added Validation
sohel 10/12/2022 2700453848 Trigger Group -> normal changes
sohel 10/12/2022 2700453848 Trigger and Trigger Group -> Added code Validation and Autosuggestion.
sohel 10/12/2022 2700453848 Triggers, Trigger Group -> Added breadcrumbs,label changes,pagination changes
raghu 10/13/2022 2700453848 Trigger Code and Group Code Auto Suggestions UI Popover Alignments Issue Fixed
sohel 10/14/2022 2700453848 Trigger Group -> Added Comments.
sohel 10/17/2022 2700453848 Changed Reset Condition.
dilip 10/17/2022 2700453848 changed Trigger Group code comment
dilip 10/17/2022 2700453848 Triggers -> Added tooltip, Changed page option and fixed group code validation issue
Raghu 10/27/2022 2700453848 Input Field Enhancements and Font size fixes
Ashraf  10/28/2022  2700453848 Added search trigger group button
Sohel 11/03/2022 2700453848 label Changes
Sohel 11/04/2022 2700453848 Access method label Changes
Sohel 11/18/2022 2700453848 run Batch trigger Group changes
Akhila 11/23/2022 2700453848 disable save button if data is empty
Akhila 11/23/2022 2700453848 change filter method field option label rendering only description
Sohel 11/23/2022 2700453848 Added Alert Popup
Akhila 11/25/2022 2700453848 validation message, textField label name, placeholder change
akhila 11/26/2022 2700453848 changed labels for code and description
Lalitha 30/11/2022 2700453848   Added validation on code
Sohel 07/12/2022  2700453848 Trigger validation after touched field
Lalitha 12/09/2022 2700453848  Added reusable backButtonText
Akhila 12/15/2022 2700453848 Added Role based access
Dilip 12/30/2022 2700453848 renamed labels for code and description
sai krishna 1/2/2023 2700453848 add code for popup
dilip 01/04/2023 2700453848 added mode field
Sohel 02/15/2023 2701350359 Batch Triggers Add Agency Changes Changes
Raghu 02/23/2023 2701350359 fixed new Ui changes
Akhila 04/03/2023 2701350359 Added functionality for corporate name and site name
Sohel 04/04/2023 2698811066 Fixed Validation Issue
Sohel 04/05/2023 2698811066 Client Code Dropdown Value Changes
Sohel 04/07/2023 2699823790 Client Code and Site Name Prepopulate issue
Akhila 05/31/2023 2699823790 unsaved changes bug fixed
Sohel 06/21/2023 2692790263 Disabled Save and Save Next Button
Sohel 06/21/2023 2692790263 Fixed Reset Issue
Akhila 06/21/2023 2692790263 conditionally disable save and finish button on submission
*/

import React, {useContext, useRef, useState} from 'react';
import {Button} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddClientTable from './AddClientTable';
import {
  postTriggerGroup,
  resetMessage,
  fetchTriggerGroup,
  getDropDownData,
} from '../../../../../redux/reducers/TriggerGroup';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from './../../../../../components/PageLoader/index';
import {ErrorSnackbar} from './../../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import {useEffect} from 'react';
import BreadCrums from '../../../../../util/BreadCrum';
import {
  fetchClientNumberDropDownData,
  fetchCompanyDropDownData,
  fetchCorporateDropDownData,
} from '../../../../../redux/reducers/clientMangement/Organizaation';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

export default function AddTrigger({
  setTabValue,
  value,
  handleTabChange,
  handleBack,
  handleNext,
  handleDirty,
  rowSelected,
}) {
  const [clientFormData, setClientFormData] = useState([]);
  const [deletedClientData, setDeletedClientData] = useState([]);
  const [deletedGroupClientPhase, setDeletedGroupClientPhase] = useState([]);

  const [deletedClientPhaseData, setDeletedClientPhaseData] = useState([]);
  const [label, setLabel] = useState('');
  const saveRef = useRef();
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    addTriggerGroupStatus,
    isLoading,
    successMsg,
    errorMsg,
    triggerGroupData,
    batchTriggerId,
    isBatchTriggersDraft,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Batch Triggers']?.BT;
  useEffect(() => {
    if (triggerGroupData?.triggerGroupClientResponseList?.length > 0) {
      const triggerGroupClientData = triggerGroupData?.triggerGroupClientResponseList?.map(
        (item) => {
          return {
            ...item,
            clientCode: item?.clientCode || '',
            // correspondingClients: item?.correspondingClients || "",
            corporateName: item?.corporate || '',
            siteName: item?.site || '',
            tableData: item?.groupClientId,
            phase: item?.phase || null,
            type: item?.type || '',
            eventTactic: item?.triggerCodePhaseList?.map((i) => {
              return {
                ...i,
                code: i?.triggerCode || '',
                groupClientPhaseId: i?.groupClientPhaseId || 0,
              };
            }),
          };
        },
      );
      setClientFormData(triggerGroupClientData);
    }
  }, [triggerGroupData]);

  useEffect(() => {
    if (successMsg || errorMsg) {
      if (successMsg) {
        setDeletedGroupClientPhase([])
        setDeletedClientData([])
      }
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addTriggerGroupStatus === 200 && successMsg) {
      setTimeout(() => {
        if (addTriggerGroupStatus === 200 && successMsg && !saveRef.current) {
          handleNext('1');
        }
        // dispatch(resetMessage());
      }, 3000);
    }
  }, [addTriggerGroupStatus, successMsg]);
  useEffect(() => {
    if (addTriggerGroupStatus === 200 && successMsg && batchTriggerId && saveRef.current) {
      dispatch(fetchTriggerGroup(batchTriggerId));
    }
  }, [addTriggerGroupStatus, successMsg]);
  useEffect(() => {
    if (batchTriggerId) {
      dispatch(fetchTriggerGroup(batchTriggerId));
    }
  }, [batchTriggerId]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(fetchClientNumberDropDownData());
    dispatch(fetchCorporateDropDownData());
    dispatch(fetchCompanyDropDownData());
  }, []);

  const onSubmit = () => {
    dispatch(submissionStart());
    const client =
      clientFormData?.length > 0 ?
        clientFormData?.map((item) => {
          return {
            clientCode: item?.clientCode || '',
            // correspondingClients: item?.correspondingClients || "",
            corporate: item?.corporateName || '',
            site: item?.siteName || '',
            groupClientId: item?.groupClientId ? item?.groupClientId : 0,
            deletedGroupClientPhaseId:
                deletedGroupClientPhase?.length > 0 ? deletedGroupClientPhase : [0],
            phase: item?.phase ? item?.phase : null,
            type: item?.type ? item?.type : '',
            triggerCodePhaseList: item?.eventTactic?.map((i) => {
              return {
                groupClientPhaseId: i?.groupClientPhaseId ? i?.groupClientPhaseId : 0,
                triggerCode: i?.code ? i?.code : '',
                triggerId : i?.id || i?.triggerId || 0,
              };
            }),
          };
        }) :
        [];
    const passValues = {
      accessMethodInfo: triggerGroupData?.accessMethodInfo ?
        triggerGroupData?.accessMethodInfo :
        null,
      triggerGroupId: triggerGroupData?.triggerGroupId || 0,
      deletedGroupClientId: deletedClientData,
      groupCode: triggerGroupData?.groupCode ? triggerGroupData?.groupCode : '',
      groupDescription: triggerGroupData?.groupDescription ?
        triggerGroupData?.groupDescription :
        '',
      triggerGroupClientRequest: client,
      mode: triggerGroupData?.mode ? triggerGroupData?.mode : '',
      isDraft: 'N',
      lastStep:
        isBatchTriggersDraft === 'N' ?
          triggerGroupData?.lastStep :
          saveRef.current ?
            triggerGroupData?.lastStep :
            2,
    };
    dispatch(postTriggerGroup(passValues));
  };

  return (
    <>
      <div className={`mb-0`}>
        <BreadCrums
          name={'Batch Trigger Name'}
          code={triggerGroupData?.groupCode}
          description={'Batch Trigger Description'}
          descriptionValue={triggerGroupData?.groupDescription}
        />
        <div className={`border-rounded`}>
          <AddClientTable
            clientFormData={clientFormData}
            setClientFormData={setClientFormData}
            setDeletedClientData={setDeletedClientData}
            deletedClientData={deletedClientData}
            setDeletedClientPhaseData={setDeletedClientPhaseData}
            deletedClientPhaseData={deletedClientPhaseData}
            label={label}
            setLabel={setLabel}
            setDeletedGroupClientPhase={setDeletedGroupClientPhase}
            handleDirty={handleDirty}
            rowSelected={rowSelected}
          />
        </div>
        <div className="row justify-content-center mt-4 mb-2 new-standard-textfields">
          <Button
            variant="outlined"
            className={`reset-btn mr-1 ${classes.buttonRoot}`}
            onClick={handleBack}
          >
            Back
          </Button>
          {/* {isBatchTriggersDraft === "N" && ( */}
          <Button
            type="submit"
            variant="outlined"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            disabled={errorMsg || successMsg || isLoading || enabledSubmission || (rowSelected && !roleDataDisable?.edit)}
            onClick={() => {
              saveRef.current = true;
              onSubmit();
            }}
          >
            Save
          </Button>
          {/* )} */}
          <Button
            variant="outlined"
            type="submit"
            className={`search-btn ml-1 ${classes.buttonRoot}`}
            disabled={errorMsg || successMsg || isLoading || enabledSubmission ||(rowSelected && !roleDataDisable?.edit)}
            onClick={() => {
              saveRef.current = false;
              onSubmit();
            }}
          >
            Save & Next
          </Button>
        </div>
      </div>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {/* {unique && (
        <ErrorSnackbar
          errorMsg={
            label === "CLIENT"
              ? "This Client Code and Phase Already Exists"
              : "This Agency Already Exists"
          }
        />
      )} */}
    </>
  );
}
